import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl, baseurImage } from "../../Baseurl";
import Swal from "sweetalert2";
import axiosInstance from "../../api/axiosInstance";

export default function ViewLab() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [lab, setLab] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expandedServices, setExpandedServices] = useState(false);

  const truncateText = (text, maxLength = 100) => {
    if (!text) return "-";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const getServiceNames = () => {
    if (!lab || !lab.services || !Array.isArray(lab.services)) return "";
    return lab.services
      .map((service) => service.serviceName || service.service || service.name || "")
      .filter(Boolean)
      .join(", ");
  };

  useEffect(() => {
    if (id) {
      fetchLabDetails();
    }
  }, [id]);

  const fetchLabDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`getLabById/${id}`);
      if (response.data.success) {
        setLab(response.data.data);
      } else {
        Swal.fire("Error", "Failed to fetch lab details", "error");
        navigate(-1);
      }
    } catch (error) {
      console.error("Error fetching lab details:", error);
      Swal.fire("Error", "Failed to fetch lab details", "error");
      navigate(-1);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-2">Loading lab details...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!lab) {
    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="col-12">
            <div className="card">
              <div className="card-body text-center">
                <p>Lab not found</p>
                <button className="btn btn-primary" onClick={() => navigate(-1)}>
                  Go Back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Lab Details
              </h5>
            </div>
            <div className="card-body" style={{ margin: "15px" }}>
              <div className="row justify-content-center mb-4">
                {lab.image && (
                  <div className="col-md-4 text-center">
                    <img
                      src={`${baseurImage}${lab.image}`}
                      alt={lab.lab_name}
                      className="img-fluid rounded"
                      style={{ maxHeight: "250px", objectFit: "contain" }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                    <div
                      style={{
                        display: 'none',
                        width: '200px',
                        height: '200px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '8px',
                        margin: '0 auto',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #ddd'
                      }}
                    >
                      <i className="ti ti-building f-48 text-muted"></i>
                    </div>
                  </div>
                )}
              </div>

              <div className="row">
                {[
                  ["Lab Name", lab.lab_name],
                  ["Email", lab.email],
                  ["Phone", lab.phone_number],
                  ["Address", lab.address],
                  ["Speciality", lab.speciality || "N/A"],
                  ["Status", lab.is_active ? "Active" : "Inactive"],
                  ["Requests", lab.assigned_count || 0],
                ].map(([label, value], idx) => (
                  <div className="col-md-6 mb-3" key={idx}>
                    <label className="form-label">{label}</label>
                    <input
                      type="text"
                      className="form-control"
                      value={value}
                      disabled
                    />
                  </div>
                ))}

                {/* Services field with truncation */}
                {lab.services && lab.services.length > 0 && (
                  <div className="col-12 mb-3">
                    <label className="form-label">Services</label>
                    <div className="form-control" style={{ minHeight: "38px", backgroundColor: "#e9ecef" }}>
                      <span>{expandedServices ? getServiceNames() : truncateText(getServiceNames(), 100)}</span>
                      {getServiceNames().length > 100 && (
                        <button
                          onClick={() => setExpandedServices(!expandedServices)}
                          className="btn btn-link btn-sm p-0 ms-2"
                          style={{ fontSize: "0.9em", textDecoration: "none" }}
                        >
                          {expandedServices ? "Show less" : "Show more"}
                        </button>
                      )}
                    </div>
                  </div>
                )}

                {lab.notes && (
                  <div className="col-12 mb-3">
                    <label className="form-label">Notes</label>
                    <textarea
                      className="form-control"
                      value={lab.notes}
                      rows="3"
                      disabled
                    />
                  </div>
                )}
              </div>

              {/* <div className="text-end mt-4">
                <button
                  className="btn btn-secondary me-2"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => navigate(`/Admin/EditLab/${lab.id}`, { state: { lab } })}
                >
                  Edit Lab
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

